import {
  Array,
  Boolean,
  Null,
  Number,
  Record,
  Static,
  String,
} from "runtypes";
import { TemplateQuestionRunType } from "./ITemplate";

export const TemplateDirectorRequestRuntype = Record({
  questions: Array(TemplateQuestionRunType),
  schoolId: Number,
});

export interface ITemplateDirectorRequest
  extends Static<typeof TemplateDirectorRequestRuntype> {}

  export const TemplateDirectorRequestRuntype2 = Record({
    defaultNegativeText: String,
    defaultPositiveText: String,
    defaultReversed: Boolean,
    defaultScale: Number,
    enableParentQuestions: Boolean,
    name: String,
    parentId: Number.Or(Null),
    questions: Array(TemplateQuestionRunType),
    schoolId: Number,
    type: Number,
  });
  
  export interface ITemplateDirectorRequest2
    extends Static<typeof TemplateDirectorRequestRuntype2> {}
  


// WEBPACK FOOTER //
// ./src/services/ITemplateDirectorRequest.ts